import cx from 'clsx'
import React, { ReactNode } from 'react'

import s from './styles.module.scss'

import { StatusColorEnum } from './StatusColorEnum'

interface IBadgeProps {
  bgColor?: StatusColorEnum
  children?: ReactNode
  classname?: string
}

const Badge = ({ bgColor, children, classname }: IBadgeProps) => {
  const classes = cx(bgColor && s[bgColor], s.badge, classname)

  return <span className={classes}>{children}</span>
}

export default Badge
